import { render, staticRenderFns } from "./Working.vue?vue&type=template&id=3570bac0&"
import script from "./Working.vue?vue&type=script&lang=ts&"
export * from "./Working.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports